import type { Middleware } from 'redux';
import { showMessage, hiddenMessage } from './applicationSlice';

const applicationMiddleware: Middleware<any> = store => next => action => {
  if (action?.type?.includes?.('rejected')) {
    if (action?.payload && action?.payload?.message) {
      const id = new Date().getTime();
      store.dispatch(
        showMessage({
          delay: 3000,
          payload: {
            title: 'Error',
            message: action?.payload?.message,
          },
          id,
          type: 'error',
        }),
      );
      setTimeout(() => {
        store.dispatch(hiddenMessage({ id }));
      }, 3000);
    }
  }

  next(action);
};

export default applicationMiddleware;
